<div class="question-card">
  <p-card>
    <!-- Floating tag at the top -->
    <div class="floating-tag" *ngIf="question?.NODE!=''">
      <span class="tag-text">{{ question?.NODE }}</span>
    </div>
    
    <div class="question-line-div">
      <div class="problem-statement">
        <span>{{index + 1}}. </span>
        <ng-container *ngFor="let part of statementParts">
          <span *ngIf="part.type === 'text'">{{ part.content }}</span>
          <img
            *ngIf="part.type === 'image'"
            [src]="part.content"
            class="question-image"
            alt="Question image"
          />
          <pre
            *ngIf="part.type === 'code'"
            class="code-block"
          ><code>{{ part.content }}</code></pre>
        </ng-container>
      </div>
      <div *ngIf="isActionAllowed" class="action-btn">
        <p-button
          icon="pi pi-pen-to-square"
          severity="danger"
          pTooltip="{{ QUESTION_CARD_STRINGS.updateQuestionTooltip }}"
          tooltipPosition="bottom"
          class="edit"
          [text]="true"
          (click)="openQuestionForm()"
          *ngIf="mode == MODE.listQuestion"
        ></p-button>

        <p-button
          icon="pi pi-trash"
          severity="danger"
          pTooltip="{{ QUESTION_CARD_STRINGS.deleteQuestionTooltip }}"
          tooltipPosition="bottom"
          class="delete"
          [text]="true"
          *ngIf="mode == MODE.listQuestion || mode == MODE.editTest || mode == MODE.bulkAdd"
          (click)="isInLibrary ? (mode == MODE.bulkAdd ? deleteQuestionFromBulkAdd() : deleteQuestionFromLibrary())
            : deleteQuestionFromTestPool()"
        ></p-button>

        <p-button
          icon="pi pi-plus"
          severity="danger"
          pTooltip="{{ QUESTION_CARD_STRINGS.addQuestionTooltip }}"
          tooltipPosition="bottom"
          class="delete"
          [text]="true"
          (click)="addQuestionToTestPool()"
          *ngIf="mode == MODE.questionPool"
        ></p-button>
      </div>
    </div>
    
    <!-- Separation line between question and options -->
    <div class="question-divider"></div>
    
    <div class="options-list">
      <label
        [ngClass]="{
          'option-bold': question?.CORRECT_ANSWER?.includes(OPTIONS.option1)
        }"
      >
        <span class="option-prefix">1.</span>
        <span class="option-content">
          <ng-container *ngFor="let part of optionParts[0]">
            <span *ngIf="part.type === 'text'">{{ part.content }}</span>
            <img
              *ngIf="part.type === 'image'"
              [src]="part.content"
              class="question-image"
              alt="Option image"
            />
            <pre
              *ngIf="part.type === 'code'"
              class="code-block"
            ><code>{{ part.content }}</code></pre>
          </ng-container>
        </span>
        <i
          class="pi no-pointer"
          *ngIf="isAnsweredQuestion && candidateAnswer?.includes(OPTIONS.option1)"
          [ngClass]="{
            'pi-check icon-green': question?.CORRECT_ANSWER?.includes(OPTIONS.option1),
            'pi-times icon-red': !question?.CORRECT_ANSWER?.includes(OPTIONS.option1)
          }"
        ></i>
      </label>
      <label
        [ngClass]="{
          'option-bold': question?.CORRECT_ANSWER?.includes(OPTIONS.option2)
        }"
      >
        <span class="option-prefix">2.</span>
        <span class="option-content">
          <ng-container *ngFor="let part of optionParts[1]">
            <span *ngIf="part.type === 'text'">{{ part.content }}</span>
            <img
              *ngIf="part.type === 'image'"
              [src]="part.content"
              class="question-image"
              alt="Option image"
            />
            <pre
              *ngIf="part.type === 'code'"
              class="code-block"
            ><code>{{ part.content }}</code></pre>
          </ng-container>
        </span>
        <i
          class="pi no-pointer"
          *ngIf="isAnsweredQuestion && candidateAnswer?.includes(OPTIONS.option2)"
          [ngClass]="{
            'pi-check icon-green': question?.CORRECT_ANSWER?.includes(OPTIONS.option2),
            'pi-times icon-red': !question?.CORRECT_ANSWER?.includes(OPTIONS.option2)
          }"
        ></i>
      </label>
      <label
        [ngClass]="{
          'option-bold': question?.CORRECT_ANSWER?.includes(OPTIONS.option3)
        }"
      >
        <span class="option-prefix">3.</span>
        <span class="option-content">
          <ng-container *ngFor="let part of optionParts[2]">
            <span *ngIf="part.type === 'text'">{{ part.content }}</span>
            <img
              *ngIf="part.type === 'image'"
              [src]="part.content"
              class="question-image"
              alt="Option image"
            />
            <pre
              *ngIf="part.type === 'code'"
              class="code-block"
            ><code>{{ part.content }}</code></pre>
          </ng-container>
        </span>
        <i
          class="pi no-pointer"
          *ngIf="isAnsweredQuestion && candidateAnswer?.includes(OPTIONS.option3)"
          [ngClass]="{
            'pi-check icon-green': question?.CORRECT_ANSWER?.includes(OPTIONS.option3),
            'pi-times icon-red': !question?.CORRECT_ANSWER?.includes(OPTIONS.option3)
          }"
        ></i>
      </label>
      <label
        [ngClass]="{
          'option-bold': question?.CORRECT_ANSWER?.includes(OPTIONS.option4)
        }"
      >
        <span class="option-prefix">4.</span>
        <span class="option-content">
          <ng-container *ngFor="let part of optionParts[3]">
            <span *ngIf="part.type === 'text'">{{ part.content }}</span>
            <img
              *ngIf="part.type === 'image'"
              [src]="part.content"
              class="question-image"
              alt="Option image"
            />
            <pre
              *ngIf="part.type === 'code'"
              class="code-block"
            ><code>{{ part.content }}</code></pre>
          </ng-container>
        </span>
        <i
          class="pi no-pointer"
          *ngIf="isAnsweredQuestion && candidateAnswer?.includes(OPTIONS.option4)"
          [ngClass]="{
            'pi-check icon-green': question?.CORRECT_ANSWER?.includes(OPTIONS.option4),
            'pi-times icon-red': !question?.CORRECT_ANSWER?.includes(OPTIONS.option4)
          }"
        ></i>
      </label>
    </div>
  </p-card>
</div>
